import React, { useState } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  RadioGroup,
  Radio,
  Stack,
  Text,
} from '@chakra-ui/react'

// Lista de fornecedores com nomes mais descritivos
const FORNECEDORES = [
  { id: 24, nome: 'XBZ Importadora' },
  { id: 32, nome: 'Asia Link Trading' },
  { id: 155, nome: 'Spot Brindes' },
]

function ModalAdicionarProdutos({ isOpen, onClose, isLoading, onAdicionarProdutos }) {
  const [fornecedor, setFornecedor] = useState('')
  const [error, setError] = useState(false)

  const handleSubmit = () => {
    if (!fornecedor) {
      setError(true)
      return
    }

    onAdicionarProdutos(parseInt(fornecedor))
  }

  const handleClose = () => {
    setFornecedor('')
    setError(false)
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Adicionar Produtos</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={4}>Selecione o fornecedor para adicionar todos os produtos que ainda não foram incluídos no sistema.</Text>

          <FormControl isInvalid={error} isRequired>
            <FormLabel>Fornecedor</FormLabel>
            <RadioGroup
              value={fornecedor}
              onChange={(value) => {
                setFornecedor(value)
                setError(false)
              }}
            >
              <Stack spacing={2}>
                {FORNECEDORES.map((item) => (
                  <Radio key={item.id} value={item.id.toString()}>
                    {item.nome}
                  </Radio>
                ))}
              </Stack>
            </RadioGroup>
            {error && <FormErrorMessage>Selecione um fornecedor</FormErrorMessage>}
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={handleClose} isDisabled={isLoading}>
            Cancelar
          </Button>
          <Button colorScheme="blue" onClick={handleSubmit} isLoading={isLoading} loadingText="Adicionando...">
            Adicionar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ModalAdicionarProdutos
